import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import modals from './modals';

const ANIMATION_TIMEOUT = 200;

export class ModalRoot extends Component {
  render() {
    const { modalType, modalProps } = this.props;
    const ModalComponent = modals[modalType];

    return (
      <CSSTransitionGroup
        component="div"
        transitionName="modal"
        transitionEnterTimeout={ANIMATION_TIMEOUT}
        transitionLeaveTimeout={ANIMATION_TIMEOUT}
      >
        {ModalComponent ? <ModalComponent {...modalProps}/> : null}
      </CSSTransitionGroup>
    );
  }
}

ModalRoot.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.object,
};

const mapStateToProps = state => ({
  modalType: state.modal.type,
  modalProps: state.modal.props,
  auth: state.auth,
});

export default connect(mapStateToProps)(ModalRoot);



// WEBPACK FOOTER //
// ./app/containers/modal-root/modal-root.js